import { render, staticRenderFns } from "./Blogroll.vue?vue&type=template&id=3c993be0&scoped=true"
import script from "./Blogroll.vue?vue&type=script&lang=js"
export * from "./Blogroll.vue?vue&type=script&lang=js"
import style0 from "./Blogroll.vue?vue&type=style&index=0&id=3c993be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c993be0",
  null
  
)

export default component.exports